import React from 'react'
import Button from 'tfs.button'

import PopUp from '../PopUp'
import getLabels from '../../utils/getLabels'

export default props => {
  const { classes } = props

  if (!props.serviceStatus.isGlobalMessageVisible) {
    return null
  }

  return (
    <PopUp>
      <article>
        <h1 className={classes.title}>{getLabels('global_message_title')}</h1>

        <p>{getLabels('global_message_body')}</p>

        {props.serviceStatus.isGlobalMessageRemovable && (
          <div className={classes.cta}>
            <Button type="button" onClick={props.closeGlobalMessage}>
              {getLabels('global_message_cta')}
            </Button>
          </div>
        )}
      </article>
    </PopUp>
  )
}
